import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";

// Hook customizado para facilitar o acesso ao contexto de autenticação
export const useAuth = () => {
  return useContext(AuthContext);
};
